'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslations';
import { EXTERNAL_LINKS } from '@/constants/routes';
import './HeroSection.scss';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="hero-section" aria-label="Hero">
      <div className="hero-section__inner">
        <div className="hero-section__content">
          <span className="hero-section__badge">{t('hero.badge')}</span>

          <h1 className="hero-section__title">
            {t('hero.titleBefore')}
            <span className="hero-section__title-highlight">
              {t('hero.titleHighlight')}
            </span>
          </h1>

          <p className="hero-section__subtitle">{t('hero.subtitle')}</p>

          <Link
            href={EXTERNAL_LINKS.START_HIRING}
            className="hero-section__cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('hero.cta')}
            <Image
              src="/arrow-right.svg"
              alt=""
              width={24}
              height={24}
              className="hero-section__cta-icon"
              aria-hidden
            />
          </Link>
        </div>

        <div className="hero-section__media">
          <Image
            src="/hero-img.png"
            alt={t('hero.imageAlt')}
            width={580}
            height={582}
            className="hero-section__image"
            priority
          />
        </div>
      </div>
    </section>
  );
}
